import React from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBBadge, MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import '../styles/Resume.css'
const timelineData = [
  {
    date: "2018",
    title: "SSC",
    description: "I have done my 10th standard at Govt high School , chandragiri with CGPA of 9.3",
    badgeClass: "success",
    btnLink: "school"
  },
  {
    date: "2020",
    title: "Intermediate",
    description: "I done my plus two on MPC at Govt Junior College , chandragiri with 9.29 CGPA ",
    badgeClass: "primary",
    btnLink: "university"
  },
  {
    date: "2024",
    title: "Btech, ECE",
    description: "I have done my graduation on ECE stream at CREC , tirupati with 8.7 CGPA",
    badgeClass: "info",
    btnLink: "graduation-cap"
    
  },
  {
    date: "2024",
    title: "Internship",
    description: "Currently i am working as a web & android Application development intern at Bodhasoft  ",
    badgeClass: "warning",
    btnLink: "chalkboard-teacher"
  },
];

const Resume = () => {
  return (
    <center>
      <center ><h1 className='m-heading'>Education &<span className='m-span'> Experience</span></h1>
      <p className='p' style={{fontSize:"15px"}} >Those are services where i can deliver Quality output in a given time</p></center>

    <MDBContainer className="py-5">

      <MDBRow>
        <MDBCol lg="12">
          <div className="horizontal-timeline">
            <ul className="list-inline items">
              {timelineData.map((event, index) => (
                <li key={index} className="list-inline-item items-list">
                  <div className="px-4">
                    <MDBBadge color={event.badgeClass} className="event-date" >{event.date}</MDBBadge>
                    <MDBIcon fas icon={event.btnLink} className="e-icon" /><br/>
                    <h5 className="pt-2">{event.title} 
                   
                    </h5>
                    <p className="text-muted">{event.description}</p>
                    {/* <div>
                      <MDBBtn href={event.btnLink} size="sm">Read more</MDBBtn>
                    </div> */}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </center>
  );
}

export default Resume;
